import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    id = '',
    password = '',
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.admin.changeUserPwd, {
        id,
        password,
    }, options);
    if (error) return { error, status };
    return content || { };
};
